export enum VerticalPlaylist {
  GtlPlaylistOffers = 'gtlPlaylistOffers',
  ModuleArtistPlaylist = 'moduleArtistPlaylist',
  ModuleOffers = 'moduleOffers',
  ModuleVenues = 'moduleVenues',
  SimilarOffers = 'similarOffers',
  ThematicSearchOffers = 'thematicSearchOffers',
  ThematicSearchVenues = 'thematicSearchVenues',
  VenueOffers = 'venueOffers',
  ArtistOffers = 'artistOffers',
  RecommendationOffers = 'recommendationOffers',
}
